export default {
  "recent_activity":"Attività recente",
  "you_have_unfinished_invoice":"Hai una fattura non completata",
  "you_have_unfinished_estimate":"Hai un preventivo non completato",
  "invoice":"Fattura",
  "estimate":"Preventivo",
  "home":"Home",
  "document":"Documento",
  "client":"Cliente",
  "report":"Rapporto",
  "new":"Nuovo",
  "no_client_found":"Nessun cliente trovato.",
  "search":"Cerca",
  "clients":"Clienti",
  "documents":"Documenti",
  "no_document_found":"Nessun documento trovato.",
  "cancel":"Annulla",
  "new_client":"Nuovo cliente",
  "add_client":"Aggiungi cliente",
  "client_name_is_required":"Il nome del cliente è obbligatorio!",
  "client_name":"Nome del cliente",
  "email":"Email",
  "phone":"Telefono",
  "mobile":"Cellulare",
  "fax":"Fax",
  "address":"Indirizzo",
  "address_1":"Indirizzo 1",
  "address_2":"Indirizzo 2",
  "city":"Città",
  "state_province":"Stato/Provincia",
  "zip_postal_code":"CAP",
  "country":"Paese",
  "filter_documents":"Filtra documenti",
  "apply_filter":"Applica filtro",
  "document_type":"Tipo di documento",
  "all":"Tutti",
  "send_state":"Stato invio",
  "sent":"Inviato",
  "not_sent":"Non inviato",
  "payment_state":"Stato pagamento",
  "paid":"Pagato",
  "not_paid":"Non pagato",
  "overdue":"Scaduto",
  "date":"Data",
  "this_month":"Questo mese",
  "this_year":"Quest'anno",
  "custom":"Personalizzato",
  "from":"Da",
  "to":"A",
  "preview":"Anteprima",
  "summary":"Riepilogo",
  "estimate_number":"Numero preventivo",
  "issued":"Emesso",
  "valid_until":"Valido fino al",
  "history":"Storico",
  "show":"Mostra",
  "share":"Condividi",
  "print":"Stampa",
  "download_pdf":"Scarica PDF",
  "send_estimate":"Invia preventivo",
  "document_history":"Storico documento",
  "mark_as_paid":"Segna come pagato",
  "paid":"Pagato",
  "invoice_number":"Numero fattura",
  "due":"Scadenza",
  "send_invoice":"Invia fattura",
  "new_item":"Nuovo articolo",
  "name":"Nome",
  "price":"Prezzo",
  "item_name":"Nome articolo",
  "item_price":"Prezzo articolo",
  "item_name_is_required":"Il nome dell'articolo è obbligatorio!",
  "item_price_is_required":"Il prezzo dell'articolo è obbligatorio!",
  "item_tax_state":"Stato fiscale articolo",
  "add_item":"Aggiungi articolo",
  "new_service":"Nuovo servizio",
  "unit":"Unità (Ora, Giorno)",
  "service_name_is_required":"Il nome del servizio è obbligatorio!",
  "service_price_is_required":"Il prezzo del servizio è obbligatorio!",
  "tax":"Tassa",
  "service_tax_state":"Stato fiscale servizio",
  "add_service":"Aggiungi servizio",
  "items_and_services":"Articoli e servizi",
  "items":"Articoli",
  "item":"Articolo",
  "services":"Servizi",
  "update_item":"Aggiorna articolo",
  "are_you_sure":"Sei sicuro?",
  "this_action_will_delete_the_item":"Questa azione eliminerà l'articolo.",
  "delete":"Elimina",
  "update":"Aggiorna",
  "update_service":"Aggiorna servizio",
  "this_action_will_delete_the_service":"Questa azione eliminerà il servizio.",
  "business":"Azienda",
  "business_details":"Dettagli azienda",
  "business_details_1":"Dettagli azienda",
  "business_logo":"Logo azienda",
  "business_name":"Nome azienda",
  "business_name_is_required":"Il nome dell'azienda è obbligatorio!",
  "mobile_number":"Numero cellulare",
  "mobile_number_2":"Numero cellulare 2",
  "website":"Sito web",
  "street":"Via",
  "street_2":"Via 2",
  "save":"Salva",
  "settings":"Impostazioni",
  "business_settings":"Impostazioni azienda",
  "payment_options":"Opzioni di pagamento",
  "tax_settings":"Impostazioni tasse",
  "document_settings":"Impostazioni documenti",
  "template_design_and_settings":"Design e impostazioni template",
  "app_settings":"Impostazioni app",
  "language":"Lingua",
  "theme":"Tema",
  "dark":"Scuro",
  "light":"Chiaro",
  "auto":"Auto",
  "subscription":"Abbonamento",
  "rate_us":"Valutaci",
  "paypal_email_is_required":"Email PayPal obbligatoria",
  "online_payments":"Pagamenti online",
  "paypal":"PayPal",
  "paypal_email":"Email PayPal",
  "stripe":"Stripe",
  "payment_instructions":"Istruzioni di pagamento",
  "add_instructions":"Aggiungi istruzioni per ricevere il pagamento:\n- informazioni conto bancario.\n- Venmo, Zelle, Cash App.\n- altre informazioni.",
  "apply_tax_to_documents":"Applica tasse ai documenti",
  "tax_label":"Etichetta tassa",
  "option_1":"Opzione 1 (%)",
  "option_2":"Opzione 2 (%)",
  "option_3":"Opzione 3 (%)",
  "itemsandservices":"Articoli&Servizi",
  "preview_and_customize":"Anteprima e personalizza",
  "new_estimate":"Nuovo preventivo",
  "add_itemandservice":"Aggiungi articolo/servizio",
  "sub-total":"Subtotale",
  "discount":"Sconto",
  "total":"Totale",
  "estimate_notes":"Note preventivo",
  "create_estimate":"Crea preventivo",
  "new_invoice":"Nuova fattura",
  "invoice_notes":"Note fattura",
  "create_invoice":"Crea fattura",
  "client_details":"Dettagli cliente",
  "save_changes":"Salva modifiche",
  "remove_this_client_from_the_document":"Rimuovi questo cliente dal documento!",
  "contact":"Contatto",
  "update_invoice":"Aggiorna fattura",
  "item_details":"Dettagli articolo",
  "remove_this_item_from_the_document":"Rimuovi questo articolo dal documento!",
  "quantity":"Quantità",
  "item_quantity_is_required!":"Quantità articolo obbligatoria!",
  "total_price":"Prezzo totale",
  "service_details":"Dettagli servizio",
  "remove_this_service_from_the_document":"Rimuovi questo servizio dal documento!",
  "unit_type":"Tipo unità",
  "service_quantity_is_required":"Quantità servizio obbligatoria",
  "select_terms":"Seleziona condizioni",
  "taxable":"Tassabile",
  "non_taxable":"Non tassabile",
  "total_estimates":"Totale preventivi",
  "total_invoices":"Totale fatture",
  "service_name":"Nome servizio",
  "service_price":"Prezzo servizio",
  "no_item_found":"Nessun articolo trovato.",
  "no_service_found":"Nessun servizio trovato.",
  "select_your_language":"Seleziona la tua lingua",
  "stripe_invoice_link":"Link fattura Stripe",
  "update_estimate":"Aggiorna preventivo",
  "sub_total":"Subtotale",
  "select_a_currency":"Seleziona una valuta",
  "reports":"Rapporti",
  "customize":"Personalizza",
  "edit":"Modifica",
  "invoices":"Fatture",
  "estimates":"Preventivi",
  "get_statement":"Ottieni estratto conto",
  "no_client_found_with_the_given_id":"Nessun cliente trovato con l'ID fornito.",
  "no_statement_found":"Nessun estratto conto trovato",
  "no_document_found_for_this_client":"Nessun documento trovato per questo cliente.",
  "client_statment":"Estratto cliente",
  "send_statment":"Invia estratto conto",
  "update_client":"Aggiorna cliente",
  "remove_this_item":"Rimuovi questo articolo",
  "remove_this_service":"Rimuovi questo servizio",
  "set_as_default":"Imposta come predefinito",
  "top_invoiced_clients":"CLIENTI PIÙ FATTURATI",
  "amount":"Importo",
  "invoices_up":"FATTURE",
  "quarter":"Trimestre",
  "unpaid":"Non pagato",
  "top_invoiced_items":"ARTICOLI PIÙ FATTURATI",
  "quantity_up":"Quantità",
  "top_invoiced_services":"SERVIZI PIÙ FATTURATI",
  "last_year":"Anno scorso",
  "life_time":"Durata totale",
  "ok":"OK",
  "invoice_send_template_subject":"Fattura #{document_number} da {business_name}",
  "invoice_send_template_email":"Ciao {client_name},\n \nSpero tu stia bene.\n \nAbbiamo emesso una nuova fattura (#{document_number}) da {business_name}.\n \nPuoi visualizzarla o scaricarla in sicurezza tramite il link qui sotto:\n \n🔗 https://snapbill.app/document/{document_id}\n \nSe hai domande su questa fattura o hai bisogno di assistenza, non esitare a contattarci a {business_email}.\n \nGrazie per aver scelto {business_name}.\n \nApprezziamo la tua collaborazione!\n \nCordiali saluti,\n \nIl team {business_name}",
  "estimate_send_template_subject":"Preventivo #{document_number} da {business_name}",
  "estimate_send_template_email":"Ciao {client_name},\n \nSpero tu stia bene.\n \nAbbiamo preparato un preventivo (#{document_number}) da {business_name} per la tua revisione.\n \nPuoi visualizzarlo o scaricarlo in sicurezza tramite il link qui sotto:\n \n🔗 https://snapbill.app/document/{document_id}\n \nSe hai domande, desideri modifiche o vuoi procedere, rispondi semplicemente a questa email o contattaci a {business_email}.\n \nGrazie per aver considerato {business_name}.\n \nNon vediamo l'ora di collaborare con te!\n \nCordiali saluti,\n \nIl team {business_name}",
  "statement_send_template_subject":"Estratto conto da {business_name}",
  "statement_send_template_email":"Ciao {client_name},\n \nSpero tu stia bene.\n \nIl tuo ultimo estratto conto da {business_name} è ora disponibile.\nQuesto estratto fornisce un riepilogo delle tue fatture e preventivi per la tua revisione.\n \nPuoi visualizzarlo o scaricarlo in sicurezza tramite il link qui sotto:\n \n🔗 https://snapbill.app/statement/{statment_number}\n \nSe hai domande su questo estratto o hai bisogno di ulteriori dettagli, non esitare a contattarci a {business_email}.\n \nGrazie per aver scelto {business_name}.\n \nCordiali saluti,\n \nIl team {business_name}",
  "no_internet_connection":"Nessuna connessione Internet",
  "you_need_an_internet_connection_to_send_or_share_your_invoice":"Hai bisogno di una connessione Internet per inviare o condividere la tua fattura.\nControlla la connessione e riprova più tardi, oppure scegli una delle opzioni offline (Stampa o Scarica PDF) per continuare.",
  "you_need_an_internet_connection_to_send_or_share_your_estimate":"Hai bisogno di una connessione Internet per inviare o condividere il tuo preventivo.\nControlla la connessione e riprova più tardi, oppure scegli una delle opzioni offline (Stampa o Scarica PDF) per continuare.",
  "you_need_an_internet_connection_to_send_or_share_your_statment":"Hai bisogno di una connessione Internet per inviare o condividere il tuo estratto conto.\nControlla la connessione e riprova più tardi, oppure scegli una delle opzioni offline (Stampa o Scarica PDF) per continuare.",
  "error":"Errore",
  "mail_composer_is_not_available_on_this_device":"Il compositore di email non è disponibile su questo dispositivo",
  "estimate_full_capital":"PREVENTIVO",
  "invoice_full_capital":"FATTURA",
  "estimate_to":"PREVENTIVO A",
  "invoice_to":"FATTURA A",
  "invoice_no":"N. Fattura:",
  "issue_date":"Data emissione:",
  "due_date":"Data scadenza:",
  "valid_until":"Valido fino a:",
  "description":"Descrizione",
  "unit_price":"Prezzo unitario",
  "note":"Nota:",
  "number_1":"Numero 1",
  "number_2":"Numero 2",
  "bill_to":"Fatturare a",
  "from_full_capital":"DA",
  "details_full_capital":"DETTAGLI",
  "valid": "Valido",
    "select_contact": "Seleziona contatto",
    "no_contacts": "Nessun contatto trovato",
    "import_from_contacts": "Importa dai contatti",
    "call": "Chiamata",
    "message": "Messaggio",
    "success": "Successo",
    "pdf_saved": "PDF salvato! Apri File → Su iPhone → SnapBill",
    "not_send": "Non inviato",
    "created": "Creato",
    "send_to": "Invia a",
    "signatures": "Firme",
    "signature": "Firma",
    "new_signature": "Nuova firma",
    "signature_name_is_required": "Il nome della firma è obbligatorio",
    "clear": "Cancella",
    "delete_signature": "Elimina firma",
    "this_action_will_delete_the_signature": "Questa azione eliminerà la firma.",
    "no_signatures_found": "Nessuna firma trovata",
    "add_your_signature": "Aggiungi la tua firma",
    "this_action_will_remove_the_signature_from_this_document": "Questa azione rimuoverà la firma da questo documento.",
    "on_receipt": "Al ricevimento",
    "three_days": "3 giorni",
    "ten_days": "10 giorni",
    "thirty_days": "30 giorni",
    "no_duo_date": "Nessuna data di scadenza",
    "no_valid_date": "Nessuna data valida",
    "select_date": "Seleziona data",
    "percentage": "Percentuale",
    "fix": "Fisso",
    "please_add_client_detail_to_the_invoice": "Per favore aggiungi i dati del cliente alla fattura",
    "please_add_at_least_one_item_to_the_invoice": "Per favore aggiungi almeno un articolo alla fattura",
    "please_add_client_detail_to_the_estimate": "Per favore aggiungi i dati del cliente al preventivo",
    "please_add_at_least_one_item_to_the_estimate": "Per favore aggiungi almeno un articolo al preventivo",
    "next": "Avanti",
    "get_started": "Inizia",
    "create_invoices_and_estimates_in_seconds": "Crea fatture e preventivi in pochi secondi",
    "auto_fill_client_details": "Compila automaticamente i dati del cliente, applica modelli e invia in meno di 20 secondi.",
    "get_paid_faster_and_know_it_instantly": "Ricevi i pagamenti più velocemente e vieni informato subito",
    "snapbill_notifies_you_the_moment": "SnapBill ti avvisa nel momento in cui i clienti aprono la tua fattura o avviano il pagamento. Niente più dubbi: solo aggiornamenti in tempo reale e un flusso di cassa più rapido.",
    "see_your_business_in_full_color": "Guarda la tua attività a colori",
    "visualize_income_trends": "Visualizza le tendenze di incasso, monitora le fatture scadute e individua i tuoi migliori clienti grazie a report chiari e intelligenti che ti aiutano a crescere con sicurezza.",
    "unlimited_access": "Accesso illimitato",
    "not_sure_yet": "Non sei ancora sicuro?",
    "enable_free_access": "Attiva l'accesso gratuito",
    "best_offer": "Migliore offerta",
    "yearly_plan": "Piano annuale",
    "per_week": "a settimana",
    "three_days_free_trail": "3 giorni di prova gratuita",
    "weekly_plan": "Piano settimanale",
    "countinue_with_three_days_free": "Continua con 3 giorni gratis",
    "countinue_with_best_offer": "Continua con la migliore offerta",
    "privacy": "Privacy",
    "already_subscribed": "Hai già un abbonamento?",
    "terms": "Termini",
    "please_select_different_plan": "Per favore seleziona un piano diverso",
    "your_current_plan": "Il tuo piano attuale",
    "statment_of_account": "Estratto conto",
    "statment_date": "Data dell'estratto",
    "classic": "Classico",
    "modern": "Moderno",
    "wave": "Wave",
    "estimate_no": "Preventivo n°:",
    "pay_now":"Paga ora",
    "copy":"Copia",
    "copied":"Copiato",
    "invalid_stripe_invoice_link":"Collegamento alla fattura Stripe non valido",
    "client_name_viewed_your_invoice_document_number":"{client_name} ha visualizzato la fattura n. {document_number}",
    "client_name_viewed_your_estimate_document_number":"{client_name} ha visualizzato il preventivo n. {document_number}",
    "client_name_started_paying_invoice":"{client_name} ha iniziato il pagamento della fattura n. {document_number} tramite {payment_method}",
    "good_news":"Buone notizie!"
} 